export default __webpack_public_path__ + "static/media/Cynthia_Fields_Africa_I_50_x_100_cm.0bb23a93.jpg";